import React, { Component } from "react";
import { primary_s5_l60 } from "../../../../lib/colors";
import { MdClose } from "react-icons/md";

import A from "../../../../Anchor/Anchor";
import Price from "../../../../Price/Price";
import CartQuantity from "../../../../CartQuantity/CartQuantity";

import "./SingleCartItem.scss";

class SingleCartItem extends Component {
  render() {
    let {
      product,
      onIncrement,
      onDecrement,
      onRemove,
      primaryColor,
      uiVariantButton,
    } = this.props;

    return (
      <div className="cart-menu-item">
        <div className="single-item">
          <div className="img-container">
            <img src={product.image} alt={product.name} />
          </div>
          <div className="info-container">
            <div className="info-remove">
              <div className="info">
                <div className="name">{product.name}</div>
                <div className="price">
                  <span
                    className={`prev-price ${
                      product.listPrice ? "" : "hidden"
                    }`}
                    style={{ color: primary_s5_l60(primaryColor) }}
                  >
                    <Price amount={product.listPrice} />
                  </span>
                  <Price amount={product.price} />
                </div>
              </div>
              <div className="remove-item">
                <A href="#" onClick={onRemove}>
                  <MdClose />
                </A>
              </div>
            </div>
            <CartQuantity
              value={product.quantity}
              onIncrement={onIncrement}
              onDecrement={onDecrement}
              primaryColor={primaryColor}
              uiVariantButton={uiVariantButton}
            />
          </div>
        </div>
        <hr />
      </div>
    );
  }
}

export default SingleCartItem;
